// https://usehooks-ts.com/react-hook/use-media-query
import { IS_SERVER } from "@/constants";
import { useEffect, useState } from "react";
/**
 * The viewport is evaluated on CSR using the provided query.
 * Returns **true** by default during SSR.
 *
 *
 * ### Usages
 *
 * ```tsx
 * const matches = useMediaQuery('(min-width: 768px)')
 *
 * ```
 * ### SSR value
 * Best practice is to always mount components during SSR, regardless of the viewport
 * To that intent, useMediaQuery hook always returns true during SSR
 */
export const useMediaQuery = (query) => {
    const getMatches = (query) => {
        if (IS_SERVER)
            return true;
        return window.matchMedia(query).matches;
    };
    const [matches, setMatches] = useState(true);
    const handleChange = () => setMatches(getMatches(query));
    useEffect(() => {
        handleChange();
        const matchMedia = window.matchMedia(query);
        matchMedia.addEventListener("change", handleChange);
        return () => {
            matchMedia.removeEventListener("change", handleChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);
    return matches;
};
